import * as React from 'react'
import { ButtonGroup, MenuItem, MenuList, ClickAwayListener, Paper, Popper } from "@mui/material"
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import OneButton from '../OneButton/OneButton'

export default function OneSplitButton({ options, label, onClick, allDisabled, secondButtonDisabled, onOptionSelect }) {
    // É necessário colocar name e value para que o menu funcione
    const [openSplitButton, setOpenSplitButton] = React.useState(false)
    const anchorRef = React.useRef(null)

    const handleToggleSplitButton = () => {
        setOpenSplitButton((prevOpen) => !prevOpen)
    }

    const handleCloseSplitButton = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }
        setOpenSplitButton(false)
    }

    // Nova função para lidar com a seleção de um item
    const handleMenuItemClick = (option) => {
        onOptionSelect(option.value) // Chama a função passada pelo pai com o valor
        setOpenSplitButton(false) // Fecha o menu
    }

    return (
        <React.Fragment>
            <ButtonGroup ref={anchorRef}>
                <OneButton
                    variant="contained"
                    disabled={allDisabled}
                    newSx={{
                        border: allDisabled ? '0px !important' : '1px solid #9b59b6',
                        paddingRight: '5px',
                        backgroundColor: allDisabled ? '#9b59b6 !important' : '#9b59b6',
                        '&:hover': {
                            backgroundColor: allDisabled ? '#8e44ad !important' : '#8e44ad'
                        }
                    }}
                    onClick={onClick}
                >
                    <span style={{ paddingLeft: '5px ' }}>
                        {label}
                    </span>
                </OneButton>
                <OneButton
                    variant="contained"
                    color="one_primary"
                    disabled={secondButtonDisabled || allDisabled}
                    newSx={{
                        border: allDisabled ? '0px !important' : '1px solid #9b59b6',
                        backgroundColor: allDisabled ? '#9b59b6 !important' : '#9b59b6',
                        '&:hover': {
                            backgroundColor: allDisabled ? '#8e44ad !important' : '#8e44ad'
                        }
                    }}
                    IconEnd={ArrowDropDown}
                    disableSpan={true}
                    onClick={handleToggleSplitButton}
                />
            </ButtonGroup>
            <Popper open={openSplitButton} anchorEl={anchorRef.current} placement="bottom-end">
                <Paper>
                    <ClickAwayListener onClickAway={handleCloseSplitButton}>
                        <MenuList>
                            {options.map((option, i) => (
                                <MenuItem
                                    key={i}
                                    onClick={() => handleMenuItemClick(option)}
                                    sx={{ fontSize: '13px' }}
                                >
                                    {option.name}
                                </MenuItem>
                            ))}
                        </MenuList>
                    </ClickAwayListener>
                </Paper>
            </Popper>
        </React.Fragment>
    )
}
